export default function IconGantPlus () {
  return (
    <svg width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="7" height="7" rx="1.5" stroke="#D5DCDF" stroke-width="1"/>
      <path d="M4.40695 3.59375H5.84514V4.40761H4.40695H3.5931H2.15491V3.59375H3.5931H4.40695Z" fill="#D5DCDF"/>
      <path d="M3.5931 2.15491H4.40761V5.84514H3.5931V2.15491Z" fill="#D5DCDF"/>
    </svg>
  )
}
